export default function Hero() {
  return (
    <section 
      className="relative min-h-[70vh] flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(15, 23, 42, 0.92) 0%, rgba(15, 23, 42, 0.85) 50%, rgba(15, 23, 42, 0.78) 100%), url('https://public.readdy.ai/ai/img_res/910f7bac6c1f6d03e13f05c0a841e023.jpg')`
      }}
    >
      <div className="container mx-auto px-6 lg:px-12 py-20">
        <div className="max-w-4xl">
          <h1 className="font-serif text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
            About Us
          </h1>
          <p className="text-2xl lg:text-3xl text-slate-200 leading-relaxed mb-4">
            The Algorithmic Consistency Initiative, LLC
          </p>
          <p className="text-xl lg:text-2xl text-slate-300 leading-relaxed">
            Bridging Technical Safety and Civil Rights
          </p>
        </div>
      </div>
    </section>
  );
}
